/* eslint-disable @typescript-eslint/no-explicit-any */
import { OidcService } from '@revenuewell/logic-oidc';
import { AuthApiService } from '@revenuewell/logic-http';
import { NavigationService } from '@revenuewell/logic-navigation';
import { AuditLogRequest } from './types';

export default class AuditService extends AuthApiService {
  private config: any;

  constructor(config: any, oidcService: OidcService) {
    super(oidcService, new NavigationService());
    this.config = config;
    return this;
  }

  log = async (request: AuditLogRequest) => {
    const url = `${this.config.legacyMessenger.apiUrl}/audit/log`;
    await this.authFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(request)
    });
  }
}
